import React from "react";
import Modal from "../../../components/modal/Modal";
import { Button } from "../../../components/buttons/button/Button";
import ModalSizes from "../../../enums/modalSizes";

interface HttpsWarningModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const HttpsWarningModal: React.FC<HttpsWarningModalProps> = ({ open, onClose, onConfirm }) => {
  return (
    <Modal
      title="Confirm changes"
      open={open}
      size={ModalSizes.tiny}
      onCancel={onClose}
      renderModalActions={() => (
        <>
          <Button onClick={onClose} basic color="blue">
            Cancel
          </Button>
          <Button onClick={onConfirm} primary>
            Continue
          </Button>
        </>
      )}
    >
      It looks like you're using an HTTPS protocol (which is less common), would you like to continue?
    </Modal>
  );
};

export default HttpsWarningModal;
